var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModeling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 27.3337L24.3274 22.659C24.5121 22.5553 24.6365 22.3702 24.6626 22.1601L26.0003 11.4324L16.1779 8.71613C16.0617 8.68398 15.9389 8.68398 15.8226 8.71613L6.0003 11.4324L7.33796 22.1601C7.36415 22.3702 7.48856 22.5553 7.67315 22.659L16.0003 27.3337ZM6.0003 11.4324L16.0003 16.2719M26.0003 11.4324L16.0003 16.2719M16.0003 16.2719V27.3337M15.667 11.667V3.66699M18.0003 6.00033L15.667 3.66699L13.3337 6.00033M10.5105 19.8879L3.37207 25.2574M6.63131 25.7734L3.37207 25.2574L3.88804 21.9982M21.3722 19.8879L28.5107 25.2574M25.2514 25.7734L28.5107 25.2574L27.9947 21.9982",
    stroke: "#126DC8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeling);
export default __webpack_public_path__ + "static/media/modeling.9dcbe8afca6e2476414409c38bc09e71.svg";
export { ForwardRef as ReactComponent };